<template>
  <div class="relative mx-auto my-10 flex justify-center uppercase">
    <hr class="absolute inset-x-0 top-1/2 translate-y-1/2 border-black-40" />
    <h3
      class="relative bg-white px-4 text-base tracking-wide text-black-80 md:px-4"
    >
      <slot />
    </h3>
  </div>
</template>
